import { useMenuContext } from 'context/menu-context'

import { Nav, LogoContainer, Logo, Menu, MenuItem, MenuButton } from './styled'

export const Header = () => {
  const { menuItems } = useMenuContext()

  const handleScrollToSection = (element: HTMLDivElement) => {
    element.scrollIntoView()
  }

  return (
    <Nav>
      <LogoContainer href="/">
        <Logo />
      </LogoContainer>

      <Menu>
        {menuItems.map(item => (
          <MenuItem $isActive={item.isVisible} key={item.label}>
            <MenuButton
              type="button"
              disabled={item.isVisible}
              onClick={() => handleScrollToSection(item.element)}
            >
              {item.label}
            </MenuButton>
          </MenuItem>
        ))}
      </Menu>
    </Nav>
  )
}
